import { render, staticRenderFns } from "./TermsOfUseModal.vue?vue&type=template&id=dd7f0dfc&scoped=true"
import script from "./TermsOfUseModal.vue?vue&type=script&lang=js"
export * from "./TermsOfUseModal.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseModal.vue?vue&type=style&index=0&id=dd7f0dfc&prod&lang=scss&scoped=true"
import style1 from "./TermsOfUseModal.vue?vue&type=style&index=1&id=dd7f0dfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7f0dfc",
  null
  
)

export default component.exports